module.exports = __webpack_public_path__ + "static/promo-a8c8d91f4ee32c3752ba00dbb05cae97.jpg";